import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { getAnalytics, logEvent } from 'firebase/analytics';
import AudioPlayer from '../components/AudioPlayer';

const Track = () => {
  const { trackId } = useParams();
  const location = useLocation();

  useEffect(() => {
    logEvent(getAnalytics(), 'screen_view', {
      firebase_screen: 'track',
    });
  }, []);

  // Each navigation opens fresh details, including another title selected in a drawer.
  return (
    trackId ?
      <AudioPlayer key={`${trackId}:${location.key}`} trackId={trackId} /> :
      <div>missing track id</div>
  );
};

export default Track;
